

import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const GuaranteeCardTwo: React.FC = () => {
  const [dentistName] = useState("Dr. Manish Sharma");
  const [patientsCovered] = useState(40);
  const [guarantee] = useState(92);
  const [status] = useState<"active" | "expired" | "pending">("pending");
  const [validity] = useState("15 Jan 2026");

  const badgeClass =
    status === "active"
      ? "bg-success"
      : status === "expired"
      ? "bg-danger"
      : "bg-warning text-dark";

  return (
    <div
      className="card shadow-container border-0 rounded-4 mb-3"
      // style={{ maxWidth: "480px" }}
    >
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="d-flex align-items-start">
            <div
              className="bg-primary bg-gradient text-white rounded-3 d-flex align-items-center justify-content-center me-3"
              style={{ width: "56px", height: "56px" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 2c1 2 1.5 3 2 4 1 2 2 3 2 6 0 4-2 7-6 7s-6-3-6-7c0-3 1-4 2-6 .5-1 1-2 2-4"
                />
              </svg>
            </div>

            <div>
              <h5 className="card-title mb-1">Teeth Guarantee</h5>
              <p className="text-muted small mb-1">
                {dentistName} • {patientsCovered} patients
              </p>
              <span className={`badge ${badgeClass}`}>
                {status.charAt(0).toUpperCase() + status.slice(1)}
              </span>
            </div>
          </div>

          <div className="text-end">
            <small className="text-muted d-block">Guarantee</small>
            <h4 className="mb-0 fw-bold">{guarantee}%</h4>
          </div>
        </div>

        <div className="progress mb-2" style={{ height: "6px" }}>
          <div
            className="progress-bar bg-primary"
            style={{ width: `${guarantee}%` }}
          ></div>
        </div>
        <div className="d-flex justify-content-between text-muted small mb-3">
          <span>Oral Health Score</span>
          <span>{guarantee}% Target</span>
        </div>

        <div className="row g-2 mb-3">
          <div className="col">
            <div className="bg-light rounded-3 p-2">
              <small className="text-muted d-block">Patients</small>
              <strong>{patientsCovered}</strong>
            </div>
          </div>
          <div className="col">
            <div className="bg-light rounded-3 p-2">
              <small className="text-muted d-block">Validity</small>
              <strong>{validity}</strong>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <div>
            <button className="btn btn-outline-secondary btn-sm me-2">
              <i className="bi bi-info-circle me-1"></i> Details
            </button>
            <button className="btn btn-primary text-white btn-sm">
              <i className="bi bi-gear me-1"></i> Manage
            </button>
          </div>

          <small className="text-muted">
            Updated: <span className="fw-semibold text-dark">5 days ago</span>
          </small>
        </div>

        <hr className="mt-4 mb-2" />

        <small className="text-muted">
          <strong className="text-dark">Guarantee Notes:</strong> Regular checkups
          and proper dental care improve guarantee validity.
        </small>
      </div>
    </div>
  );
};

export default GuaranteeCardTwo;
